import { type RouteObject } from 'react-router-dom'
import { LegacyPage } from '../pages/Legacy/Legacy'
import { SearchPage } from '../pages/Search/Search'
import { CalendarPage } from '../pages/Calendar/Calendar'
import { getRoutes, type RouteKey } from './routes'
import { makeRedirectPage } from './RedirectPage'
type WithComponents = { [K in RouteKey]: React.ComponentType }

const routes = getRoutes()
const withComponents: WithComponents = {
  campaignHome: LegacyPage,
  emailInbox: LegacyPage,
  legacy: LegacyPage,
  tutorials: LegacyPage,
  lessons: LegacyPage,
  campaignSearch: SearchPage,
  campaignJournalists: SearchPage,
  campaignSettings: SearchPage,
  unlinkedMentions: LegacyPage,
  brokenLinkBuilding: LegacyPage,
  calendar: CalendarPage,
  legacySearch: makeRedirectPage('/a/search', { injectBrandId: true }),
}

const componentRoutes: RouteObject[] = routes.map(route => ({
  ...route,
  Component: withComponents[route.id],
}))

export const getComponentRoutes = (): RouteObject[] => componentRoutes
